module.exports = __webpack_public_path__ + "static/media/pinterest.9f73c33d.svg";